export const USER_DETAILS_CHANGE_TRACKING = {
  profileDetails: {
    source: 'user_details.profile_details',
    id: 17001,
  },
  pendingCharges: {
    source: 'user_details.pending_charges',
    id: 17002,
  },
  roles: {
    source: 'user_details.roles',
    id: 17003,
  },
  permissions: {
    source: 'user_details.permissions',
    id: 17004,
  },
  documents: {
    source: 'user_details.documents',
    id: 17005,
  },
  changePassword: {
    source: 'user_details.change_password',
    id: 17101,
  },
  documentsDelete: {
    source: 'user_details.documents.delete',
    id: 17102,
  },
  documentsUpload: {
    source: 'user_details.documents.upload',
    id: 17103,
  },
  pendingChargesSave: {
    source: 'user_details.pending_charges.save',
    id: 17104,
  },
  profilePhotoUpload: {
    source: 'user_details.profile_details.photo_upload',
    id: 17105,
  },
  postingGroupDelete: {
    source: 'user_details.profile_details.posting_group.delete',
    id: 17106,
  },
  postingGroupUpdate: {
    source: 'user_details.profile_details.posting_group.update',
    id: 17107,
  },
  storeGoogleCredential: {
    source: 'user_details.profile_details.store_google_credential',
    id: 17108,
  },
} as const;
